import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '@/api/common';
import type { AdminReservation } from '@/api/reservations/types';

import { toReservationRequestBody } from './reservation-payload';
import type { AdminReservationDraft } from './types';

// Live price preview for the reservation summary sidebar. Same payload and
// response shape as the create endpoint, but nothing is persisted. Modeled
// as a query (despite the POST) so the sidebar refetches when the draft
// changes and identical drafts hit the cache.
export const useAdminReservationQuote = createQuery<
  AdminReservation,
  AdminReservationDraft,
  AxiosError
>({
  queryKey: ['internal/partners/reservations/quote'],
  fetcher: (draft) =>
    client
      .post(
        'v2/internal/partners/reservations/quote',
        toReservationRequestBody(draft)
      )
      .then((response) => response.data.data),
  retry: false,
});
